import { Grid } from "@mui/material";
import CopySection from "assets/FileAdd.svg";
import { ReactComponent as CopyLink } from "assets/copy_link.svg";
import {
  clearSelectedCards,
  setActiveActionCard,
  setCopyActionPopupEnabled,
  setSelectedCards
} from "components/app/App.slice";
import Button from "components/common/Button";
import CheckBox from "components/common/Checkbox";
import Feedback from "components/common/Feedback";
import KebabMenu from "components/common/KebabMenu";
import Timing from "components/common/Timing";
import { useContext, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { FEEDBACK_TIMER, accessTypes } from "utils/CommonConstants";
import { getHoursAndMin } from "utils/CommonFunctions";
import { planTypes } from "utils/Types";
import { REDIRECT_URI } from "utils/URLConstants";
import { checkCopyActionAccess } from "../CopyToPlan/Helper";
import ActionCardDialogsContext from "./Context";
import { SummaryTooltip } from "./SummaryTooltip";

interface Props {
  timeEstimateMinutes: string;
  multiCardSelect: boolean;
  item: any;
  sectionId?: any;
  planId?: any;
}

function AllPlans(props: Props) {
  const { id }: any = useParams();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { timeEstimateMinutes, multiCardSelect, item, sectionId, planId } = props;
  const cardList: any = useAppSelector((state) => state.app.selectedCards?.cardList);
  const [clicked, setClicked] = useState(false);
  const isCopyActionEnabled: any = useAppSelector((state) => state.app.isCopyActionEnabled);
  const [isCopyLinkSuccess, setIsCopyLinkSuccess] = useState(false);
  const { setIsOpenCopyActionDialog } = useContext(ActionCardDialogsContext);
  const isDashboardRedirect = location?.state?.redirectFromDashboard;

  const findCheckedValueById = (idToFind: number, dataArray: any) => {
    const item = dataArray.find((item: any) => item.id === idToFind);
    return item ? item.checked : null;
  };
  const checked = findCheckedValueById(item.id, cardList);

  const handleChecked = () => {
    if (clicked) dispatch(setCopyActionPopupEnabled(false));
    const dataCheck = cardList?.find((el: any) => el.id === item.id);

    if (!dataCheck) {
      const payload = {
        planId,
        sectionId,
        cardList: item
      };

      dispatch(setSelectedCards(payload));
    } else if (!checked && dataCheck && !isCopyActionEnabled) {
      dispatch(clearSelectedCards(item));
    }
  };

  const ActionCardMenu = [
    {
      label: "Copy shareable link",
      icon: CopyLink,
      action: (cardId: string) => {
        const link = planId
          ? REDIRECT_URI + "/plandetails/" + id + "/" + sectionId + "/" + cardId + "?isshareable=true"
          : REDIRECT_URI + "/library/search?q=&cardid=" + cardId;
        navigator.clipboard.writeText(link).then(function () {
          setIsCopyLinkSuccess(true);
        });
        setIsCopyLinkSuccess(false);
      },
      enabled: true
    }
  ];

  return (
    <>
      <Grid onClick={(e) => e.stopPropagation()}>
        <Feedback
          form=""
          actionStatus={{ shouldShow: isCopyLinkSuccess, variant: "success", timer: FEEDBACK_TIMER }}
          message="Link Copied"
        />
      </Grid>
      <Grid sx={{ position: "relative", height: "100%" }}>
        <Grid item xs={12} display="flex">
          {multiCardSelect ? (
            <Grid item xs={6} display="flex" onClick={(e) => e.stopPropagation()}>
              <CheckBox
                sx={{ marginLeft: "-12px" }}
                checked={cardList?.some((el: any) => el.id === item.id)}
                onChange={() => {
                  handleChecked();
                  setClicked(true);
                }}
              />
            </Grid>
          ) : (
            <Grid item xs={6} display="flex">
              <Timing color={tokens.Text.General.Secondary} duration={getHoursAndMin(timeEstimateMinutes)} />
            </Grid>
          )}

          <Grid item xs={6} display="flex" justifyContent="flex-end" onClick={(e) => e.stopPropagation()}>
            <KebabMenu value={item.id} options={ActionCardMenu} sx={{ marginRight: "-12px" }} />
          </Grid>
        </Grid>

        <Grid marginTop={3} marginBottom={2}>
          <SummaryTooltip item={item} />
        </Grid>

        {checkCopyActionAccess() && !isDashboardRedirect && (
          <Grid marginBottom={2} display="flex" justifyContent="end">
            <Button
              accessType={accessTypes.update}
              iconButton
              icon={CopySection}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  setActiveActionCard({ planId, planType: planTypes.AllPlans, sectionId, cardId: item.id, ...item })
                );
                setIsOpenCopyActionDialog(true);
              }}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default AllPlans;
